import { lazy } from 'react';

const SelfBooking = {
  PreviewPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/PreviewPage')),
  CampaignPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/CampaignPage')),
  PositionPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/PositionPage')),
  HistoryPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/HistoryPage')),
};

export default SelfBooking;
